export const tempEntitySearchKeywords = [
  {
    keyword: 'inflammation',
    freq: 14,
    category: 'Disease',
  },
  {
    keyword: 'cancer',
    freq: 10,
    category: 'Disease',
  },
  {
    keyword: 'infection',
    freq: 10,
    category: 'Disease',
  },
  {
    keyword: 'ibd',
    freq: 7,
    category: 'Disease',
  },
  {
    keyword: 'toxicity',
    freq: 7,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword',
    freq: 5,
    category: 'Disease',
  },
  {
    keyword: 'long keyword long keyword long keyword',
    freq: 4,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword2',
    freq: 3,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword3',
    freq: 2,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword4',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword5',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword6',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword7',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword8',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword9',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword10',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword11',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword12',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword13',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword14',
    freq: 1,
    category: 'Disease',
  },
  {
    keyword: 'example-keyword15',
    freq: 1,
    category: 'Disease',
  },
];

export const tempEntitySearchDocuments = [
  {
    title: `example document title`,
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
    url: 'https://www.vaiv.kr/',
  },
  {
    title: 'long document title long document title long document title long document title long document title long document title long document title',
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    url: 'https://ai.vaiv.kr/',
  },
  {
    title: `example document title`,
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has`,
    url: 'https://stock.vaiv.kr/',
  },
  {
    title: `example document title`,
    text: `Lorem Ipsumis simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    url: 'https://www.vaivcompany.kr/',
  },
  {
    title: `example document title`,
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
    url: 'https://some.co.kr/',
  },
  {
    title: `example document title`,
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
    url: 'https://some.co.kr/',
  },
  {
    title: `example document title`,
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
    url: 'https://some.co.kr/',
  },
];

export const tempRelationSearchRelations = [
  {
    relation: 'ACTIVATOR',
    freq: 14,
  },
  {
    relation: 'REGULATOR',
    freq: 10,
  },
  {
    relation: 'INHIBITOR',
    freq: 10,
  },
  {
    relation: 'SUBSTRATE',
    freq: 4,
  },
];

export const tempRelationSearchEntities = [
  {
    entity: 'inflammation',
    freq: 14,
    category: 'Disease',
  },
  {
    entity: 'cancer',
    freq: 10,
    category: 'Disease',
  },
  {
    entity: 'infection',
    freq: 10,
    category: 'Disease',
  },
  {
    entity: 'ibd',
    freq: 7,
    category: 'Disease',
  },
  {
    entity: 'toxicity',
    freq: 7,
    category: 'Disease',
  },
  {
    entity: 'example-keyword',
    freq: 5,
    category: 'Disease',
  },
  {
    entity: 'long keyword long keyword',
    freq: 4,
    category: 'Disease',
  },
  {
    entity: 'example-keyword2',
    freq: 3,
    category: 'Disease',
  },
  {
    entity: 'example-keyword3',
    freq: 2,
    category: 'Disease',
  },
  {
    entity: 'example-keyword4',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword5',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword6',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword7',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword8',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword9',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword10',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword11',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword12',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword13',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword14',
    freq: 1,
    category: 'Disease',
  },
  {
    entity: 'example-keyword15',
    freq: 1,
    category: 'Disease',
  },
];

export const tempRelationSearchDocuments = [
  {
    title: `example document title`,
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
    url: 'https://www.vaiv.kr/',
  },
  {
    title: 'long document title long document title long document title long document title long document title long document title long document title',
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    url: 'https://ai.vaiv.kr/',
  },
  {
    title: `example document title`,
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has`,
    url: 'https://stock.vaiv.kr/',
  },
  {
    title: `example document title`,
    text: `Lorem Ipsumis simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    url: 'https://www.vaivcompany.kr/',
  },
  {
    title: `example document title`,
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
    url: 'https://some.co.kr/',
  },
];

export const tempSearchGPTSummary = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`;

export const tempSearchGPTDocuments = [
  {
    title: `example document title`,
    text: `<mark>Lorem Ipsum</mark> is simply dummy text of the printing and typesetting industry.`,
    url: 'https://www.vaiv.kr/',
  },
  {
    title: 'long document title long document title long document title long document title long document title long document title long document title',
    text: `Lorem Ipsum is simply <mark>dummy text</mark> of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    url: 'https://ai.vaiv.kr/',
  },
  {
    title: `example document title`,
    text: `<mark>Lorem Ipsum</mark> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has`,
    url: 'https://stock.vaiv.kr/',
  },
  {
    title: `example document title`,
    text: `<mark>Lorem Ipsum</mark>is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    url: 'https://www.vaivcompany.kr/',
  },
  {
    title: `example document title`,
    text: `<mark>Lorem Ipsum</mark> is simply dummy text of the printing and typesetting industry.`,
    url: 'https://some.co.kr/',
  },
];

export const tempStatGeneProtein = [
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
];

export const tempStatChemicalCompound = [
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
];

export const tempStatDisease = [
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
  {
    label: 'calcium',
    freq: 148,
  },
];
